import React from "react";
import SpanRequired from "./SpanRequired";

const Label = ({...props}) => {
  const { required, className, text, onClick, htmlFor, children, ...rest } = props;
  const labelClass = `font-medium flex items-center mt-[5px] ${className || ""}`;
  return (
    <label
      className={labelClass}
      htmlFor={htmlFor ? htmlFor : null}
      onClick={onClick ? onClick : null}
      {...rest}
    >
      {text ? text : children}
      {required && <SpanRequired />}
    </label>
  );
};

export default Label;
